import { render, staticRenderFns } from "./HowUsePanel.vue?vue&type=template&id=10efda42"
import script from "./HowUsePanel.vue?vue&type=script&lang=js"
export * from "./HowUsePanel.vue?vue&type=script&lang=js"
import style0 from "./HowUsePanel.vue?vue&type=style&index=0&id=10efda42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
